module.exports = __webpack_public_path__ + "img/goodStyle-1.704a1d1e.jpg";